const SERVER = import.meta.env.VITE_API_URL;
import axios from "../../configs/axios.config";

const createNewFleet = async (formdata) => {
  console.log("Creating new fleet with data:", formdata);
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.post(`${SERVER}/inventory/newFleet`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error("Create Fleet Error:", error);

    // backend message agar ho
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }

    // network / server down
    if (error.request) {
      throw new Error("Server not responding");
    }

    // fallback
    throw new Error("Failed to create fleet");
  }
};

const getFleetsList = async (page, limit, query, operationalStatus, administrativeStatus) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const params = new URLSearchParams({
      page,
      limit,
      query,
    });

    if (operationalStatus !== "" && operationalStatus !== undefined) {
      params.append("operationalStatus", operationalStatus);
    }
    if (administrativeStatus !== "" && administrativeStatus !== undefined) {
      params.append("administrativeStatus", administrativeStatus);
    }

    let response = await axios.get(
      `${SERVER}/inventory/fleets?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching fleets:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch fleets");
  }
};
const getFleetDetails = async (id) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(`${SERVER}/inventory/fleet/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching roles:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch roles");
  }
};

const updateFleetDetails = async (id, formdata) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.patch(
      `${SERVER}/inventory/fleet/${id}`,
      formdata,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching roles:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch roles");
  }
};

const deleteFleet = async (id) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.delete(`${SERVER}/inventory/fleet/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error deleting fleet:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to delete fleet");
  }
};

const getFleetTrips = async (fleetId) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(`${SERVER}/inventory/fleet/${fleetId}/trips`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching fleet trips:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch fleet trips");
  }
};

const getFleetDriverHistory = async (fleetId) => {
  try {
    let token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");
    let response = await axios.get(`${SERVER}/inventory/fleet/${fleetId}/drivers`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch driver history");
  }
};

const getFleetAuditLogs = async (fleetId, page = 1, limit = 50) => {
  try {
    let token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");
    let response = await axios.get(`${SERVER}/inventory/fleet/${fleetId}/audit-logs?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch audit logs");
  }
};

export {
  createNewFleet,
  getFleetsList,
  getFleetDetails,
  updateFleetDetails,
  deleteFleet,
  getFleetTrips,
  getFleetDriverHistory,
  getFleetAuditLogs,
};
